import React from 'react';
import clsx from 'clsx';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
import { BaseTypography } from '../../BaseTypography/BaseTypography';
import { ISelectOption, onRemoveValueType } from '../common/types';

type SelectInputItemProps = {
  option: ISelectOption;
  onRemove: onRemoveValueType;
  className?: any;
};

// @ts-ignore
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette.primary.main,
    borderRadius: '5px',
    padding: '3.5px 10px',
    color: 'white',
    whiteSpace: 'nowrap',
  },
}));

export const SelectInputValue: React.FC<SelectInputItemProps> = (props) => {
  const classes = useStyles();
  const { onRemove, option, className } = props;

  return (
    <div className={clsx(classes.root, className)}>
      <BaseTypography variant="tag">{option.label}</BaseTypography>
      <CloseIcon
        onClick={(e) => onRemove(e, option)}
        style={{ fontSize: '18px' }}
      />
    </div>
  );
};
